import Vue from "vue";
import VueRouter from "vue-router";
import { setStorage } from "@/utils/storage";
import { windowHref } from "@/utils";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/insurance",
  },

  // 种源管理页面
  {
    path: "/seedSourceManagement",
    name: "seedSourceManagement",
    component: () => import("@/views/seedSourceManagement/index.vue"),
  },
  // 横沙生产管理系统新首页
  {
    path: "/newHsHome",
    name: "newHsHome",
    component: () => import("@/views/NewHsHome/index.vue"),
  },
  // 横沙生产管理系统新登录页
  {
    path: "/hsLogin",
    name: "hsLogin",
    component: () => import("@/views/HsLogin/index.vue"),
  },
  {
    path: "/addSeedSource",
    name: "addSeedSource",
    component: () =>
      import("@/views/seedSourceManagement/addSeedSource/index.vue"),
  },
  // 农业主体信息
  {
    path: "/argicSubjectInfo",
    name: "ArgicSubjectInfo",
    component: () => import("@/views/ArgicSubjectInfo/Index.vue"),
  },
  // 编辑农事
  {
    path: "/editFarming",
    name: "EditFarming",
    component: () => import("@/views/AviatFarmingList/EditFarming/Index.vue"),
  },
  //  补贴测算
  {
    path: "/subsidyStatistics/index",
    name: "SubsidyStatistics",
    component: () =>
      import(
        /* webpackChunkName: "Supplier" */ "@/views/SubsidyStatistics/index.vue"
      ),
  },
  //  合格证批量补打印
  {
    path: "/Certificate/batchPrint",
    name: "CertificateBatchPrint",
    component: () =>
      import(
        /* webpackChunkName: "Supplier" */ "@/views/Certificate/batchPrint.vue"
      ),
  },
  // 管理远程打印站点
  {
    path: "/Certificate/associatedSite",
    name: "CertificateAssociatedSite",
    component: () =>
      import(
        /* webpackChunkName: "Supplier" */ "@/views/Certificate/associatedSite.vue"
      ),
  },
  // 打印记录
  {
    path: "/Certificate/printRecord",
    name: "CertificatePrintRecord",
    component: () =>
      import(
        /* webpackChunkName: "Supplier" */ "@/views/Certificate/printRecord.vue"
      ),
  },
  // 打印记录详情
  {
    path: "/Certificate/printRecordDetail",
    name: "CertificatePrintRecordDetail",
    component: () =>
      import(
        /* webpackChunkName: "Supplier" */ "@/views/Certificate/printRecordDetail.vue"
      ),
  },
  // 打印记录
  {
    path: "/operateCompleted",
    name: "operateCompleted",
    component: () =>
      import(
        /* webpackChunkName: "Supplier" */ "@/views/operateCompleted/index.vue"
      ),
  },
  // 航育农事对接
  {
    path: "/aviatFarmingList",
    name: "AviatFarmingList",
    component: () => import("@/views/AviatFarmingList/Index.vue"),
  },
  // 数据上链
  {
    path: "/dataUplink",
    name: "DataUplink",
    component: () => import("@/views/DataUplink/Index.vue"),
  },
  // 上链数据表
  {
    path: "/uplinkDataSheet",
    name: "UplinkDataSheet",
    component: () => import("@/views/DataUplink/UplinkDataSheet.vue"),
  },
  // 地块上链填报
  {
    path: "/uplinkForm",
    name: "UplinkForm",
    component: () => import("@/views/DataUplink/UplinkForm.vue"),
  },
  //上链填报列表
  {
    path: "/uplinkList",
    name: "UplinkList",
    component: () => import("@/views/DataUplink/UplinkList.vue"),
  },
  // 仓储加工填报
  {
    path: "/storageProcess",
    name: "StorageProcess",
    component: () => import("@/views/StorageProcess/index.vue"),
  },
  // 仓储加工填报鸡蛋
  {
    path: "/storageProcessForEgg",
    name: "StorageProcessForEgg",
    component: () => import("@/views/StorageProcessForEgg/index.vue"),
  },
  //仓储加工录入
  {
    path: "/storageProcess-enter",
    name: "StorageProcessEnter",
    component: () => import("@/views/StorageProcess/enter.vue"),
  },
  // 仓储加工列表
  {
    path: "/storageProcessList",
    name: "StorageProcessList",
    component: () => import("@/views/StorageProcess/StorageProcessList.vue"),
  },
  //仓储加工录入
  {
    path: "/storageProcessForEgg-enter",
    name: "StorageProcessForEggEnter",
    component: () => import("@/views/StorageProcessForEgg/enter.vue"),
  },
  // 仓储加工列表
  {
    path: "/storageProcessForEggList",
    name: "StorageProcessForEggList",
    component: () =>
      import("@/views/StorageProcessForEgg/StorageProcessList.vue"),
  },
  // 受灾列表
  {
    path: "/damageList",
    name: "DamageList",
    component: () => import("@/views/DamageList/index.vue"),
  },
  // 添加批量销售
  {
    path: "/bulkSales",
    name: "BulkSales",
    component: () => import("@/views/BulkSales/addBulkSales.vue"),
    meta: {
      keepAlive: true,
    },
  },
  // 预览/打印销售单
  {
    path: "/previewBox",
    name: "PreviewBox",
    component: () => import("@/views/BulkSales/PreviewBox.vue"),
  },
  // 预览/打印销售单
  {
    path: "/previewImg",
    name: "PreviewImg",
    component: () => import("@/views/BulkSales/PreviewImg.vue"),
  },
  // 受灾详情
  {
    path: "/damage-detail",
    name: "DamageListDetail",
    component: () => import("@/views/DamageList/detailInfo.vue"),
  },
  // 添加受灾地块
  {
    path: "/damage-increase-land",
    name: "DamageListIncreaseLand",
    component: () => import("@/views/DamageList/increaseLand.vue"),
  },
  // 农业保险列表
  {
    path: "/insurance",
    name: "Insurance",
    component: () =>
      import(/* webpackChunkName: "Insurance" */ "@/views/Insurance/Index.vue"),
    beforeEnter(to, from, next) {
      console.log(from);
      if (from.path === "/") {
        setStorage("pathWhere", from.path);
      }
      next();
    },
  },

  // 详情
  {
    path: "/detailsIndex",
    name: "DetailsIndex",
    component: () =>
      import(
        /* webpackChunkName: "Insurance" */ "@/views/Insurance/DetailsIndex.vue"
      ),
    beforeEnter(to, from, next) {
      if (from.path === "/insure") {
        setStorage("pathWhere", from.path);
      }
      next();
    },
  },

  // 介绍页面
  {
    path: "/introducedJs",
    name: "IntroducedJs",
    component: () =>
      import(
        /* webpackChunkName: "Insurance" */ "@/views/Insurance/IntroducedJs/Index.vue"
      ),
    beforeEnter(to, from, next) {
      if (from.path === "/") {
        setStorage("pathWhere", from.path);
      }
      next();
    },
  },
  // 投保
  {
    path: "/insure",
    name: "Insure",
    component: () =>
      import(/* webpackChunkName: "Insure" */ "@/views/Insure/Index.vue"),
  },
  /* 大屏 */
  // 大屏农场
  {
    name: "BSFarm",
    path: "/bs/farm",
    component: () => import("@/views/bs/Farm"),
  },
  //-------穗优保险模块---start-------------
  //保险列表页
  {
    path: "/insuranceList",
    name: "InsuranceList",
    component: () =>
      import(
        /* webpackChunkName: "ruralInsurance" */ "@/views/ruralInsurance/index.vue"
      ),
  },
  //穗优订单页
  {
    path: "/ruralList",
    name: "RuralList",
    component: () =>
      import(
        /* webpackChunkName: "ruralInsurance" */ "@/views/ruralInsurance/list/index.vue"
      ),
    beforeEnter(to, from, next) {
      if (from.path === "/insuranceList") {
        setStorage("pathWhere", from.path);
      }
      next();
    },
  },
  //穗优介绍页
  {
    path: "/introduce",
    name: "Introduce",
    component: () =>
      import(
        /* webpackChunkName: "ruralInsurance" */ "@/views/ruralInsurance/introduce/index.vue"
      ),
  },
  //穗优-投保人信息填写
  {
    path: "/ruralWriteInfo",
    name: "RuralWriteInfo",
    component: () =>
      import(
        /* webpackChunkName: "ruralInsurance" */ "@/views/ruralInsurance/infoWrite/index.vue"
      ),
  },

  // 详情
  {
    path: "/ruralDetailsIndex",
    name: "ruralDetailsIndex",
    component: () =>
      import(
        /* webpackChunkName: "Insurance" */ "@/views/ruralInsurance/DetailsIndex.vue"
      ),
    // beforeEnter(to, from, next) {
    //   if (from.path === "/insure") {
    //     setStorage("pathWhere", from.path);
    //   }
    //   next();
    // },
  },
  {
    path: "/supplier/workbench",
    name: "SupplierWorkbench",
    component: () =>
      import(
        /* webpackChunkName: "Supplier" */ "@/views/Supplier/Workbench.vue"
      ),
  },
  {
    path: "/supplier/purchaserDetail",
    name: "SupplierPurchaserDetail",
    component: () =>
      import(
        /* webpackChunkName: "Supplier" */ "@/views/Supplier/PurchaserDetail.vue"
      ),
  },

  // 质量快检-机构列表
  {
    path: "/quality-inspection",
    name: "qualityInspection",
    component: () =>
      import(
        /* webpackChunkName: "qualityInspection" */ "@/views/qualityInspection/index.vue"
      ),
    beforeEnter(to, from, next) {
      if (from.path === "/") {
        setStorage("pathWhere", from.path);
      }
      next();
    },
  },
  //质量快检-结果列表
  {
    path: "/quality-result-list",
    name: "QualityResultList",
    component: () =>
      import(
        /* webpackChunkName: "qualityInspection" */ "@/views/qualityInspection/qualityList.vue"
      ),
    beforeEnter(to, from, next) {
      if (from.path === "/quality-inspection") {
        setStorage("pathWhere", from.path);
      }
      next();
    },
  },
  //质量快检-结果详情列表
  {
    path: "/quality-result-detail-list",
    name: "QualityResultDetailList",
    component: () =>
      import(
        /* webpackChunkName: "qualityInspection" */ "@/views/qualityInspection/detailList.vue"
      ),
    beforeEnter(to, from, next) {
      if (from.path === "/quality-result-list") {
        setStorage("pathWhere", from.path);
      }
      next();
    },
  },
  // 外采入库表单
  {
    path: "/OutsourcingWarehousing",
    name: "OutsourcingWarehousing",
    component: () => import("@/views/OutsourcingWarehousing"),
  },
  {
    path: "/ExpertConsultation/index",
    name: "ExpertConsultation",
    component: () => import("@/views/ExpertConsultation/index.vue"),
  },
  {
    path: "/NjWork/index",
    name: "NjWork",
    component: () => import("@/views/NjWork/index.vue"),
  },
  {
    path: "/NjWork/orderDetail",
    name: "OderDetail",
    component: () => import("@/views/NjWork/orderDetail.vue"),
  },
  {
    path: "/NjWork/applyWork",
    name: "ApplyWork",
    component: () => import("@/views/NjWork/applyWork.vue"),
  },
  //--------------end----
  // STORY#3197 专业版线上购买（路径需与老端 frp_company_web 的 PRO_PLAN_ROUTES 保持一致）
  {
    path: "/proPlan/index",
    name: "ProPlanIndex",
    component: () =>
      import(/* webpackChunkName: "proPlan" */ "@/views/ProPlan/index.vue"),
  },
  {
    path: "/proPlan/rights",
    name: "ProPlanRights",
    component: () =>
      import(/* webpackChunkName: "proPlan" */ "@/views/ProPlan/Rights.vue"),
  },
  {
    // 专业版权益详情（9 大权益逐条说明；PC 与 H5 同页实现）
    path: "/proPlan/rightsDetail",
    name: "ProPlanRightsDetail",
    component: () =>
      import(
        /* webpackChunkName: "proPlan" */ "@/views/ProPlan/RightsDetail.vue"
      ),
  },
  {
    path: "/proPlan/orderConfirm",
    name: "ProPlanOrderConfirm",
    component: () =>
      import(
        /* webpackChunkName: "proPlan" */ "@/views/ProPlan/OrderConfirm.vue"
      ),
  },
  {
    path: "/proPlan/orderSuccess",
    name: "ProPlanOrderSuccess",
    component: () =>
      import(
        /* webpackChunkName: "proPlan" */ "@/views/ProPlan/OrderSuccess.vue"
      ),
  },
  {
    path: "/proPlan/orderExpired",
    name: "ProPlanOrderExpired",
    component: () =>
      import(
        /* webpackChunkName: "proPlan" */ "@/views/ProPlan/OrderExpired.vue"
      ),
  },
  {
    path: "/proPlan/orderList",
    name: "ProPlanOrderList",
    component: () =>
      import(/* webpackChunkName: "proPlan" */ "@/views/ProPlan/OrderList.vue"),
  },
  // 访问不存在的路由时，返回首页
  {
    path: "*",
    beforeEnter() {
      windowHref("/home/home");
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
